import { randomUUID } from '@/utils';

/**
 * 生成广告数据源
 * @param {Object[]} sources 接口返回源数据
 * @returns {Object[]}
 */
export function generateAdvertiserSourcesData(sources) {
  const advertiser_sources = {};
  for (let i = 0; i < sources.length; i++) {
    const advertiser = sources[i];
    Object.assign(advertiser_sources, {
      [advertiser.advertiser_id]: {
        campaigns: advertiser.plans.map(plan => {
          return {
            ...plan.campaign,
            creatives: plan.creatives,
          };
        }),
      },
    });
  }
  return advertiser_sources;
}

/**
 * 生成表格数据源
 * @param {Object[]} advertiser_sources 广告源数据
 * @returns {Object[]}
 */
export function generateDynamicTableData(advertiser_sources) {
  const rows = [];

  Object.entries(advertiser_sources).forEach(([advertiser_id, plan], i) => {
    const campaigns = plan.campaigns;
    for (let j = 0; j < campaigns.length; j++) {
      const campaign = campaigns[j];
      const creatives = campaigns[j].creatives;
      let row = {
        campaign_uuid: randomUUID(),
        campaign,
      };
      for (let k = 0; k < creatives.length; k++) {
        const creative = creatives[k];
        row = {
          ...row,
          creative_uuid: randomUUID(),
          id: `${advertiser_id}-${i}-${j}-${k}`,
          // 标记
          custom_marker: {
            // 数据源坐标
            coordinate: {
              advertiser_id,
              advertiser: i,
              campaign: j,
              creative: k,
            },
          },
          index: `${i + 1}-${j + 1}-${k + 1}`,
          advertiser_id,
          creative,
        };
        rows.push(row);
      }
    }
  });

  return rows;
}
